import { component } from 'picoapp';
import { clear, repaint } from 'utils/node';

export default component((node) => {
  // Sort - Section Rendering API
  const productList = node.querySelector('[data-product-list]');
  const placeholderList: HTMLElement = node.querySelector('[data-placeholder-list]');
  const viewMoreBtn = node.querySelector('[data-view-more-btn]');

  const currentProductAmount = node.querySelector('[data-current-product-amount]');
  currentProductAmount.innerHTML = productList.children.length.toString();

  // Pagination
  interface CollectionConfig {
    sectionId: string,
  }

  interface ProductListConfig {
    pages: number,
  }

  const configJson: HTMLElement = node.querySelector('[data-config]');
  const collectionConfig: CollectionConfig = JSON.parse(configJson.innerHTML);
  const { sectionId } = collectionConfig;

  const fetchSection = async (url: URL, updateUrl = true) => {
    const urlToFetch = new URL(url.toString());

    urlToFetch.searchParams.set('section_id', sectionId);

    if (updateUrl) {
      window.history.replaceState({}, '', url.toString());
    }

    const response = await fetch(urlToFetch.toString());
    const markup = await response.text();

    const container = document.createElement('div');
    container.innerHTML = markup;

    return container;
  };

  const loadPreviousPages = async () => {
    const url = new URL(window.location.href);
    const currentPage = url.searchParams.get('page') ? parseInt(url.searchParams.get('page'), 10) : 1;

    const fetches = [];

    for (let page = 1; page < currentPage; page += 1) {
      url.searchParams.set('page', page.toString());
      fetches.push(fetchSection(url, false));
    }

    const html = (await Promise.all(fetches)).map((container) => (
      container.querySelector('[data-product-list]')
    )).map((list) => (
      list.innerHTML
    )).join('');

    productList.insertAdjacentHTML('afterbegin', html);
    currentProductAmount.innerHTML = productList.children.length.toString();
  };

  const loadNextPage = async () => {
    const url = new URL(window.location.href);
    const nextPage = parseInt(url.searchParams.get('page') || '1', 10) + 1;

    url.searchParams.set('page', nextPage.toString());

    const list = (await fetchSection(url)).querySelector<HTMLElement>('[data-product-list]');
    const config = (await fetchSection(url)).querySelector<HTMLElement>('[data-pages]');
    const html = list.innerHTML;

    productList.insertAdjacentHTML('beforeend', html);
    currentProductAmount.innerHTML = productList.children.length.toString();

    const productListConfig: ProductListConfig = JSON.parse(config.innerHTML);
    const { pages } = productListConfig;

    if (nextPage >= pages) {
      viewMoreBtn.remove();
    }
  };

  const renderSortedProducts = async (url: URL) => {
    const list = (await fetchSection(url)).querySelector<HTMLElement>('[data-product-list]');
    const html = list.innerHTML;

    clear(productList);

    placeholderList.hidden = false;
    repaint(placeholderList);

    await loadPreviousPages();
    productList.insertAdjacentHTML('beforeend', html);
    currentProductAmount.innerHTML = productList.children.length.toString();

    placeholderList.hidden = true;
  };

  document.addEventListener('collection:sort:apply', (event: CustomEvent) => {
    const { url } = event.detail;
    renderSortedProducts(url);
  });

  loadPreviousPages();
  viewMoreBtn?.addEventListener('click', loadNextPage);
});
